import { render, staticRenderFns } from "./goodsSubmit.vue?vue&type=template&id=504ff318&scoped=true"
import script from "./goodsSubmit.vue?vue&type=script&lang=js"
export * from "./goodsSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504ff318",
  null
  
)

export default component.exports